import {
  useHistory,
  useInitialLocation,
  useIsOrderSuccessPage,
} from '@aboutyou/router';

export enum AdjustTracker {
  APP_INSTALL_BANNER = '5corhcm',
  BROWSE_POP_UP_MWEB = '8wb72xz',
  BROWSE_BANNER = 'bnx5mk9',
  CAMPAIGN_BANNER_MWEB = '8m8y76t',
  APP_INSTALL_MWEB = 'hdfs9w4',
}

const APP_INSTALL_DOMAIN = 'https://aboutyouapp.go.link';

export const useGetUnifiedStoreLink = (params: {
  adjustTracker: AdjustTracker;
  options?: {addOnlyTrackerParam: boolean};
}) => {
  const history = useHistory();
  const isOsp = useIsOrderSuccessPage();
  const pathname = isOsp ? '/a/orders' : history.location.pathname;
  const appInstallBannerUrl = new URL(
    `${APP_INSTALL_DOMAIN}/${pathname.substring(1)}`,
  );
  appInstallBannerUrl.searchParams.set('adj_t', params.adjustTracker);

  const appInstallParams = useAppInstallParams();

  if (params.options?.addOnlyTrackerParam) {
    return appInstallBannerUrl.toString();
  }

  appInstallParams.forEach((value, key) => {
    appInstallBannerUrl.searchParams.set(key, value);
  });

  return appInstallBannerUrl.toString();
};

const useAppInstallParams = () => {
  const {search: initialSearch} = useInitialLocation();

  const initialSearchParams = new URLSearchParams(initialSearch);
  const searchParams = new URLSearchParams();

  initialSearchParams.forEach((value, key) => {
    searchParams.append(key, value);
  });

  const utmMedium = initialSearchParams.get('utm_medium');
  if (utmMedium) {
    searchParams.append('adj_campaign', utmMedium);
  }

  const utmSource = initialSearchParams.get('utm_source');
  if (utmSource) {
    searchParams.append('adj_adgroup', utmSource);
  }

  const utmCampaign = initialSearchParams.get('utm_campaign');
  if (utmCampaign) {
    searchParams.append('adj_creative', utmCampaign);
  }

  return new URLSearchParams(searchParams.toString());
};
